import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-khairagarh-chess-tournament',
  templateUrl: './khairagarh-chess-tournament.component.html',
  styleUrls: ['./khairagarh-chess-tournament.component.scss']
})
export class KhairagarhChessTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
